import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./WishlistPage.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faShoppingCart,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { useCart } from "../../context/CartContext";

const WishlistProductCard = ({ product, onRemove }: any) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);

  const firstImage = product?.picture?.[0]?.path || "";
  const hasMultipleImages = product?.picture?.length > 1;

  const handleNextImage = () => {
    if (hasMultipleImages) {
      setCurrentImageIndex((prev) =>
        prev === product.picture.length - 1 ? 0 : prev + 1
      );
    }
  };

  const originalPrice = product?.price || 0;
  const ourPrice = product?.ourPrice || 0;
  const discountPercentage = product?.discountPercentage || 0;
  const youSave = originalPrice - ourPrice;
  const { cart, addToCart, removeFromCart } = useCart();
  const navigate = useNavigate();
  return (
    <motion.div
      className={styles.productCard}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
      whileHover={{ y: -5 }}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {/* Discount Badge */}
      {discountPercentage > 0 && (
        <motion.div
          className={styles.discountBadge}
          initial={{ y: -10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
          whileHover={{ scale: 1.1 }}
        >
          {Math.round(discountPercentage)}% OFF
          <div className={styles.glowEffect}></div>
        </motion.div>
      )}

      {/* Remove from Wishlist Button */}
      <button
        className={styles.removeButton}
        onClick={onRemove}
        aria-label="Remove from wishlist"
      >
        <FontAwesomeIcon icon={faTrash} />
      </button>

      {/* Product Image */}
      <div className={styles.imageContainer} onClick={handleNextImage}>
        {firstImage ? (
          <img
            src={product.picture[currentImageIndex]?.path || firstImage}
            alt={product?.name || "Product image"}
            className={styles.productImage}
            loading="lazy"
          />
        ) : (
          <div className={styles.imagePlaceholder}>No Image Available</div>
        )}

        {/* Quick View Overlay */}
        {isHovering && (
          <motion.div
            className={styles.quickView}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <Link
              to={`/series/${product?.series.id}/product/${product?._id}`}
              className={styles.quickViewBtn}
            >
              <FontAwesomeIcon icon={faEye} /> Quick View
            </Link>
          </motion.div>
        )}
      </div>

      {/* Product Info */}
      <div className={styles.productInfo}>
        <h3
          className={styles.productName}
          onClick={() =>
            navigate(
              `/series/${
                product?.series?.id
              }/product/${product?._id.toString()}`
            )
          }
        >
          {product?.name || "Untitled Product"}
        </h3>
        <p
          className={styles.productSeries}
          onClick={() => navigate(`/series/${product?.series?.id}`)}
        >
          {product?.series?.title || ""}
        </p>

        {/* Price Display */}
        <div className={styles.priceContainer}>
          {originalPrice > ourPrice && (
            <span className={styles.originalPrice}>
              ₹{originalPrice.toFixed(2)}
            </span>
          )}
          <span className={styles.discountedPrice}>₹{ourPrice.toFixed(2)}</span>
          {youSave > 0 && (
            <span className={styles.youSave}>
              You save ₹{youSave.toFixed(2)}
            </span>
          )}
        </div>

        {/* Action Buttons */}
        <div className={styles.actionButtons}>
          <motion.button
            className={styles.moveToCartBtn}
            onClick={() => {
              cart?.some((p) => p._id.toString() === product?._id.toString())
                ? removeFromCart(product?._id)
                : addToCart({ ...product, quantity: 1 });
            }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FontAwesomeIcon icon={faShoppingCart} />{" "}
            {cart?.some((p) => p._id.toString() === product?._id.toString())
              ? "Remove from Cart"
              : "Add to Cart"}
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};
export default WishlistProductCard;
